import React, { useState, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";
import "../styles/components/form.css";
import CloseIcon from "../assets/icons/close-icon.svg";

const RequirementForm = ({ onClose, onSave }) => {
    const [requirementText, setRequirementText] = useState("");

    const isFormValid = requirementText.trim() !== "";

    const handleSubmit = (e) => {
        e.preventDefault();

        onSave(requirementText);
        onClose();
    };

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div className="modal-overlay">
            <div className="form">
                <div className="form-header">
                    <h1 className="form-title">Добавление требования</h1>
                    <button className="close-button" onClick={onClose}>
                        <img src={CloseIcon} alt="Закрыть" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="field-label">Требование</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите требование"
                            value={requirementText}
                            onChange={(e) => setRequirementText(e.target.value)}
                        />
                    </div>
                    <div className="form-buttons">
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Отменить
                        </button>
                        <button type="submit" className="save-button" disabled={!isFormValid}>
                            Сохранить
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RequirementForm;